import { cva } from "class-variance-authority";

export { default as Alert } from "./Alert.vue";
export { default as AlertAction } from "./AlertAction.vue";
export { default as AlertDescription } from "./AlertDescription.vue";
export { default as AlertTitle } from "./AlertTitle.vue";

export const alertVariants = cva(
  "grid gap-0.5 rounded-lg border px-2.5 py-2 text-left text-sm has-data-[slot=alert-action]:relative has-data-[slot=alert-action]:pr-18 has-[>svg]:grid-cols-[auto_1fr] has-[>svg]:gap-x-2 *:[svg]:row-span-2 *:[svg]:translate-y-0.5 *:[svg]:text-current *:[svg:not([class*=size-])]:size-4 group/alert relative w-full",
  {
    variants: {
      variant: {
        default: "bg-card text-card-foreground",
        destructive:
          "text-red-700 bg-red-50 border-red-300 dark:text-red-300 dark:bg-red-950/40 dark:border-red-900/60 *:data-[slot=alert-description]:text-red-600 dark:*:data-[slot=alert-description]:text-red-400 *:[svg]:text-current",
        warning:
          "text-foreground bg-amber-50 border-amber-300 dark:bg-amber-950/40 dark:border-amber-900/60 *:data-[slot=alert-description]:text-muted-foreground *:[svg]:text-amber-500",
        info:
          "text-foreground bg-blue-50 border-blue-200 dark:bg-blue-950/40 dark:border-blue-900/60 *:data-[slot=alert-description]:text-muted-foreground *:[svg]:text-blue-500",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);
